import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { useVocabularyData } from 'app/utils/vocabulary'
import { compact, uniqBy } from 'lodash'
import React, { memo, useContext } from 'react'

import { CompanyData } from './CompanyData'
import { FooterContext } from './index'
import { PolicyMenuItem } from './PolicyMenuItem'

export const Bottom = memo(function Bottom() {
  const {
    cin,
    cir,
    companyName,
    email,
    languageCode,
    phone,
    policyMenu,
    rea,
    registeredOffice,
    shareCapital,
    vat,
  } = useContext(FooterContext) as any

  let IubendaID: string = '13806624'
  switch (languageCode) {
    case 'en-US':
      IubendaID = '73150096'
      break
    default:
      IubendaID = '13806624'
      break
  }

  return (
    <Container>
      {vat ? (
        <Item>{`${useVocabularyData(
          'business-name',
          languageCode,
        )}: ${companyName} - ${useVocabularyData('vat', languageCode)} ${vat}`}</Item>
      ) : null}

      <Links dial={4} row wrap>
        {policyMenu ? (
          <Policy row wrap>
            {uniqBy(policyMenu, 'title').map((item: any, index) => (
              <PolicyMenuItem key={index} {...item} />
            ))}
          </Policy>
        ) : null}

        <IubendaLink
          href={`https://www.iubenda.com/privacy-policy/${IubendaID}`}
          className="iubenda-white iubenda-noiframe iubenda-embed iub-legal-only iubenda-noiframe"
          title="Privacy Policy"
        >
          Privacy Policy
        </IubendaLink>

        <IubendaLink
          href={`https://www.iubenda.com/privacy-policy/${IubendaID}/cookie-policy`}
          className="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe"
          title="Cookie Policy"
        >
          Cookie Policy
        </IubendaLink>

        <script
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: `(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);`,
          }}
        />

        <CompanyData
          className="item-company"
          email={email}
          cin={cin}
          cir={cir}
          companyName={companyName}
          languageCode={languageCode}
          phone={phone}
          vat={vat}
          rea={rea}
          registeredOffice={registeredOffice}
          shareCapital={shareCapital}
        />

        <Credits
          aria-label="QNT Hospitality"
          href="https://www.qnt.it"
          rel="noopenet"
          target="_blank"
        >
          {useVocabularyData('credits', languageCode)}
        </Credits>
      </Links>
    </Container>
  )
})

const Container = styled.div`
  color: ${({ theme }) => theme.colors.variants.neutralLight5};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 0.8125rem;
  font-weight: 300;
  line-height: 1.1875rem;
  margin-top: 2.5rem;

  .iubenda-embed:not(.no-brand):not(.iubenda-nostyle) {
    background: none !important;
    padding: 0 !important;
    margin-right: 1.25rem !important;
    vertical-align: top !important;
    box-shadow: none !important;
    color: ${({ theme }) => theme.colors.variants.neutralDark4}!important;
    font-family: ${({ theme }) => theme.fontFamily.paragraph}!important;
    font-weight: 300 !important;
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
    transition: 0.3s ease-in-out !important;

    &:hover {
      color: ${({ theme }) => theme.colors.variants.neutralLight5}!important;
    }

    @media (max-width: 574px) {
      margin: 0 auto 0.375rem !important;
    }
  }
`

const Item = styled.div``

const Links = styled(FlexBox)`
  margin-top: 2.0625rem;

  @media (max-width: 1199px) {
    width: 100%;
    justify-content: center;
  }
  @media (max-width: 574px) {
    flex-direction: column;
    align-items: center;

    a,
    .item-company {
      width: 100%;
      text-align: center;
      margin: 0 auto 0.375rem !important;
    }
  }
`

const Policy = styled(FlexBox)`
  .item-company {
    margin-right: 1.25rem;
    color: ${({ theme }) => theme.colors.variants.neutralDark4};
    font-size: 0.875rem;
    line-height: 1.25rem;
    transition: 0.3s ease-in-out;
    &:hover {
      color: ${({ theme }) => theme.colors.variants.neutralLight5};
    }
  }
`

const IubendaLink = styled.a`
  color: ${({ theme }) => theme.colors.variants.neutralDark4};
  transition: 0.3s ease-in-out;
  margin-right: 1.25rem;

  &:hover {
    color: ${({ theme }) => theme.colors.variants.neutralLight5};
  }

  @media (max-width: 1199px) {
    margin: 0 0.75rem;
  }
`

const Credits = styled.a`
  color: ${({ theme }) => theme.colors.variants.neutralDark4};
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-left: 1.9375rem;
  transition: 0.3s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.colors.variants.neutralLight5};
  }

  @media (max-width: 1200px) {
    margin-left: 1.25rem;
  }

  @media (min-width: 1200px) {
    width: 100%;
    margin-top: 0.5rem;
  }
  @media (min-width: 1440px) {
    margin-left: 1.25rem;
    margin-top: auto;
    width: auto;
  }
`
